module.exports = __webpack_public_path__ + "img/zjjs.1c840efd.jpg";